<template>
  <div class="order-service" :style="{ height: autoHeight }">
    <div class="order-service-wrap" ref="processWrap" v-if="processMap.length >= 0">
      <div class="main-title marTop64">
        服务进度
        <span
          class="order-service-title-sub"
          zz-sortid="100"
          zz-sortname="查看所有进度"
          @click="jumpToProcessList"
        >查看所有进度</span>
      </div>
      <div class="order-service-content">
        <div
          v-for="(info, idx) in processMap"
          :key="idx"
          :zz-sortid="idx"
          :zz-sortname="info.ticketTitle"
          class="process-item-main"
          @click="jumpToProcessDetail(info)"
        >
          <div
            class="process-item-img"
            :style="{ backgroundImage: `url('${$setPicSize(info.pic)}')` }"
          ></div>
          <div class="process-item-content">
            <p class="process-item-title">{{ info.ticketTitle }}</p>
            <p class="process-item-sub">{{ info.ticketDesc }}</p>
            <p :class="{ active: +info.ticketStatus === 3 }" class="process-item-status">
              {{ ticketStatus(info) }}
              <span v-if="+info.timeOutStatus === 2 && +info.estimatedFinishTimeStatus > 0" class="process-item-right">{{info.expectedTimeDesc}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="order-service-wrap" ref="processWrap" v-else>
      <div class="main-title marTop64">
        服务进度
        <span class="order-service-title-subnone">您还没有相关咨询哦~</span>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { getTicketsForUser } from '../../../api/resourceApi'
import { getCookie } from '../../../lib/utils'

export default {
  name: 'OrderServiceSection',
  data() {
    return {
      // timeOutStatus 超时状态  1.超时  2.非超时
      processMap: [],
      autoHeight: 0
    }
  },
  methods: {
    ticketStatus(info) {
      const statusMap = {
        1: '处理中',
        2: '处理中',
        3: '已完成',
        4: '处理中'
      }
      return statusMap[info.ticketStatus] || ''
    },
    $setPicSize(url) {
      // 后台没有返回地址给个默认的
      if (!url) {
        return setPicSize(
          'https://pic6.zhuanstatic.com/zhuanzh/21d599a8-f720-479b-b90e-b9560bd9810d.png',
          100,
          100
        )
      }
      // 部分后台返回的图片url非常规url，不做处理直接用
      const reg = /\.(png|jpg|jpeg|gif)/i
      return reg.test(url) ? setPicSize(url, 300, 200) : url
    },
    jumpToProcessList() {
      lego.send({
        pagetype: 'ZZKF_CENTER_ORDER_SERVICE',
        actiontype: 'JUMP_LIST'
      })
      // 兼容ios返回手势动作，如果使用push则会直接返回到“我的”
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/serviceprocess/list'
      })
    },
    jumpToProcessDetail(info) {
      lego.send({
        pagetype: 'ZZKF_CENTER_ORDER_SERVICE',
        actiontype: 'JUMP_DETAIL'
      })
      // 兼容ios返回手势动作，如果使用push则会直接返回到“我的”
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/serviceprocess/detail/${info.ticketId}`
      })
    },
    getServiceProcessInfo() {
      this.getUserServiceInfo()
    },
    async getUserServiceInfo() {
      let uid = ''
      // if (isZlj()) {
      //   const userRes = await getZljUid()
      //   if (!userRes) return
      //   const { uid: zljUid } = userRes
      //   uid = zljUid
      // } else {
      //   uid = getCookie('uid') || ''
      // }
      uid = getCookie('uid') || ''
      if (!uid || uid === '') return
      const params = {
        uid,
        pageSize: 10,
        pageNum: 1
      }
      const res = await getTicketsForUser(params)
      const result = res || []
      if (result && result.length === 0) {
        this.updateSectionHeight()
        return
      }
      if (!result || result.length <= 0) return
      this.processMap = result.slice(0, 2)
      this.updateSectionHeight()
    },
    updateSectionHeight() {
      this.$nextTick(() => {
        const innerRef = this.$refs.processWrap
        const height = (innerRef && innerRef.clientHeight) || 0
        if (innerRef.clientHeight == 0 || !innerRef.clientHeight) {
          this.autoHeight = 'auto'
          return
        }
        this.autoHeight = height + 'px'
      })
    }
  },
  mounted() {
    this.getServiceProcessInfo()
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
  @import '../HelpCenter.less';
</style>
